module.exports = __webpack_public_path__ + "static/media/cp03.b2d2566b.jpg";